import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CountryFlat } from '../../../models/country';
import { LookupDataService } from '../../../services/lookupDataService.service';
import { MaterialModule } from '../../../shared/material.module';
import { Helpers } from '../../../utilities/helpers';
import { OpbCompanySearchFilter } from '../../../models/opbCompanySearchFilter';

@Component({
  selector: 'app-opb-company-search-box',
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule
  ],
  templateUrl: './opb-company-search-box.component.html',
  styleUrl: './opb-company-search-box.component.scss'
})
export class OpbCompanySearchBoxComponent implements OnChanges {
  @Input() isSearchVisible: boolean = false;
  @Input() initialFilter?: OpbCompanySearchFilter;
  @Output() searchFilter = new EventEmitter<OpbCompanySearchFilter>();

  countries$: Observable<CountryFlat[]>;
  measurements: string[] = Helpers.measurements();

  searchForm: OpbCompanySearchFilter = {
    name: undefined,
    country: undefined,
    measurement: Helpers.defaultMeasurementYear(),
    isActive: true,
    isTransferred: false
  };

  constructor(private lookupDataService: LookupDataService) {
    this.countries$ = this.lookupDataService.getVisibleCountries<CountryFlat>().pipe(
      map(countries => countries.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })))
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialFilter'] && this.initialFilter) {
      this.searchForm = { ...this.initialFilter };
    }
  }

  onSearch(): void {
    this.searchFilter.emit({ ...this.searchForm });
  }

  clearSearch(): void {
    this.searchForm = {
      name: undefined,
      country: undefined,
      measurement: Helpers.defaultMeasurementYear(),
      isActive: true,
      isTransferred: false
    };
    this.searchFilter.emit({ ...this.searchForm });
  }
}
